/** How many rows to reveal on first render of an already-fetched, already
 *  in-memory list — a full page, or everything if there's less than one. */
export function initialVisibleCount(total: number, pageSize: number): number {
  return Math.min(pageSize, total);
}

/** How many rows to reveal after the scroll trigger fires — one more page,
 *  capped at the total so it never overshoots the list. */
export function nextVisibleCount(current: number, pageSize: number, total: number): number {
  return Math.min(current + pageSize, total);
}
